var Feature = /*#__PURE__*/function (Feature) {
  Feature["CategoryRow"] = "Category Row";
  Feature["CategoriesList"] = "Categories List";
  Feature["UpdateCategory"] = "Update Category";
  return Feature;
}(Feature || {});
var Page = /*#__PURE__*/function (Page) {
  Page["UnifiedActivityDetail"] = "Unified Activity Detail";
  return Page;
}(Page || {});
var Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}(Action || {});
export const viewCategoryRow = view => getEvent({
  applet: 'Balance',
  feature: Feature.CategoryRow,
  page: Page.UnifiedActivityDetail,
  action: Action.View,
  category: view.categoryId,
  transactionId: view.transactionId
});
export const clickCategoryRow = () => getEvent({
  applet: 'Balance',
  feature: Feature.CategoryRow,
  page: Page.UnifiedActivityDetail,
  action: Action.Click
});
export const viewCategoriesList = () => getEvent({
  applet: 'Balance',
  feature: Feature.CategoriesList,
  page: Page.UnifiedActivityDetail,
  action: Action.View
});
export const clickUpdateCategory = update => getEvent({
  applet: 'Balance',
  feature: Feature.UpdateCategory,
  page: Page.UnifiedActivityDetail,
  action: Action.Click,
  category: update.updatedCategoryId,
  originalCategory: update.currentCategoryId,
  transactionId: update.transactionId
});
const getEventName = (action, feature) => `${action} ${feature}`;
function getEvent(args) {
  return {
    name: getEventName(args.action, args.feature),
    properties: {
      ...args
    }
  };
}